import styled from 'styled-components';
import { breakpoints } from 'theme';

export const StyledResponseFilter = styled.div`
  position: relative;
  margin: 8px 30px 0 0;
  text-align: left;

  @media ${breakpoints.downSmPlus} {
    margin-right: 12px;
  }
`;

export const StyledResponseLabel = styled.label`
  display: block;
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.pickledBluewood};
  cursor: text;
`;

export const StyledFieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.porcelain};
  cursor: text;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-bottom-color: ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const StyledChips = styled.div<{ expanded?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  max-height: ${({ expanded }) => (expanded ? '196px' : 'none')};
  overflow-y: ${({ expanded }) => (expanded ? 'auto' : 'visible')};
`;

export const StyledChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  height: 32px;
  padding: 0 4px 0 12px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.color.porcelain};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 1px 2px ${({ theme }) => `${theme.color.pickledBluewood}14`};
  font-size: 13px;
  color: ${({ theme }) => theme.color.shark};
`;

export const StyledChipLabel = styled.span`
  min-width: 0;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${breakpoints.downSmPlus} {
    max-width: 160px;
  }
`;

export const StyledChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${({ theme }) => theme.color.baliHai};
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover,
  &:focus-visible {
    outline: none;
    background: ${({ theme }) => theme.color.blackSqueeze};
    color: ${({ theme }) => theme.color.shark};
  }
`;

export const StyledMoreChip = styled.button`
  height: 32px;
  padding: 0 12px;
  border: 1px dashed ${({ theme }) => theme.color.botticelli};
  border-radius: 999px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.BlueBayoux};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.color.brightTurquoise};
    color: ${({ theme }) => theme.color.skobeloffGreen};
  }
`;

export const StyledReplySearch = styled.input`
  flex: 1;
  min-width: 140px;
  height: 32px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.shark};

  &::placeholder {
    color: ${({ theme }) => theme.color.casper};
  }
`;

export const StyledSuggestions = styled.ul`
  position: absolute;
  z-index: 30;
  top: calc(100% - 2px);
  left: 0;
  width: min(420px, 100%);
  max-height: 260px;
  margin: 0;
  padding: 6px;
  overflow-y: auto;
  list-style: none;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.color.porcelain};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 18px 40px -12px ${({ theme }) => `${theme.color.pickledBluewood}40`};

  @media ${breakpoints.downSmPlus} {
    width: 100%;
  }
`;

export const StyledOption = styled.li<{ highlighted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  background: ${({ highlighted, theme }) =>
    highlighted ? theme.color.blackSqueeze : 'transparent'};
`;

export const StyledOptionName = styled.span`
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.shark};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledReplyEmpty = styled.li`
  padding: 12px 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.baliHai};
`;
